import React, { useState } from 'react'
import AdminLayout from '../../../layouts/AdminLayout';
import { useQuery } from '@tanstack/react-query';
import { privateApi } from '../../../api/api';
import { toast } from 'sonner';
import IframeError from '../../../shared/components/errors/IframeError';
import FullContainerSpinner from '../../../shared/components/spinner/FullContainerSpinner';
import { useAuth } from '../../../auth/context/AuthProvider';

const MessagePage: React.FC = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const { user } = useAuth();

    const { data: iframeURL, isLoading, isError, isSuccess } = useQuery({
        queryKey: ['channex', 'iframeURL'],
        queryFn: () => privateApi.get('/v4/channex-iframe-messages', {
            params: {
                filter: {
                    property_id: user?.active_property_id
                }
            }
        }).then(res => res.data),
        refetchOnWindowFocus: false,
        enabled: !!user?.active_property_id,
    });

    if (isError) {
        toast.error('Failed to fetch iframe URL');
    }

    const handleIframeLoad = () => {
        setIsLoaded(true);
    };

    return (
        <AdminLayout>
            {isError && <IframeError />}
            {isLoading || isLoaded === false && <FullContainerSpinner />}
            {isSuccess && (
                <div style={{ width: '100%', height: '100vh' }}>
                    <iframe
                        src={iframeURL}
                        width="100%"
                        height="100%"
                        onLoad={handleIframeLoad}
                        style={{
                            display: isLoaded ? "block" : "none",
                            border: "none",
                        }}
                        title="Channel Setup Channex"
                    ></iframe>
                </div>
            )}
        </AdminLayout>
    )
}

export default MessagePage